const isEmptyObject = (arg) => {
  for (const key in arg) {
    if (arg.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
};
export {
  isEmptyObject
};
//# sourceMappingURL=isEmptyObject.js.map
